import React from "react";

import { IBand } from "Bands/types";
import { FormBuilder } from "shared/components";
import { IFormButtons, IAPIError } from "shared/types";
import { fields } from "./formData";

interface BandRegionalSettingsFormProps {
  isSubmitting?: boolean;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  apiError?: IAPIError | null;
  handleSubmit: (band: IBand) => void;
}

export const BandRegionalSettingsForm: React.FC<BandRegionalSettingsFormProps> = ({
  handleSubmit,
  hasError,
  defaultValues,
  ...rest
}) => {
  const buttons: IFormButtons = {
    primary: true,
  };

  return (
    <FormBuilder
      fields={fields}
      onSubmit={(band: IBand) => handleSubmit(band)}
      defaultValues={defaultValues}
      globalError
      submitMode="isDirty"
      apiErrorMessage={hasError}
      buttons={buttons}
      {...rest}
    />
  );
};
